import { Link } from 'react-router';

export default function NotFoundPage() {
  return (
    <section style={{ textAlign: 'center', paddingTop: '4rem' }}>
      <h1 style={{ fontSize: '4rem', fontWeight: 700, color: 'var(--color-muted, #6b7280)' }}>
        404
      </h1>
      <p style={{ marginTop: '1rem', fontSize: '1.125rem' }}>Хуудас олдсонгүй.</p>
      <Link to="/" style={{ display: 'inline-block', marginTop: '1.5rem', textDecoration: 'none' }}>
        &larr; Нүүр хуудас руу буцах
      </Link>
    </section>
  );
}
